import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";

import { NzPlacementType } from "ng-zorro-antd/dropdown";
import { LabsPageService, PageInfo } from "../labs-page.service";
import { faCaretUp, faHourglassStart } from "@fortawesome/free-solid-svg-icons";
import {
  VAIconRegistryService,
  checkCircle,
  flask,
  caretDown,
} from "@va/core-library/icons";

@Component({
  selector: "app-labs-page-nav",
  templateUrl: "./labs-page-nav.component.html",
  styleUrls: ["./labs-page-nav.component.scss"],
})
export class LabsPageNavComponent implements OnInit, OnChanges {
  position: NzPlacementType = "bottomLeft";
  public labsPages: Array<PageInfo> = [];
  public pageName: string;
  faCaretUp = faCaretUp;
  watchlistlabsMenuVisible: boolean;
  isDisabled: boolean;

  // Icon
  faHourglassStart = faHourglassStart;
  @Input() labsPagesParams: any = {};

  constructor(
    private labsPageService: LabsPageService,
    private router: Router,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      checkCircle,
      checkCircle,
      flask,
      caretDown,
    ]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ("labsPagesParams" in changes) {
      if (changes.labsPagesParams.previousValue === undefined) {
        // Changes detected
        this.getMenu();
      } else if (
        "pageName" in changes.labsPagesParams.currentValue &&
        "pageName" in changes.labsPagesParams.previousValue
      ) {
        const curr = changes.labsPagesParams.currentValue;
        const prev = changes.labsPagesParams.previousValue;
        if (this.detectPageChange(curr.pageName, prev.pageName)) {
          this.getMenu();
        } else if (
          this.detectParameterChange(
            changes.labsPagesParams.currentValue.pageName,
            changes.labsPagesParams.currentValue,
            changes.labsPagesParams.previousValue,
          )
        ) {
          this.getMenu();
        }
      }
    }
  }

  ngOnInit() {
    this.labsPages = [];
    this.isDisabled = true;
  }

  public getMenu() {
    this.labsPages = [];
    this.isDisabled = true;
    this.pageName = this.labsPagesParams.pageName;
    delete this.labsPagesParams.pageName;
    const queryStr = this.createQueryString();
    if (queryStr.includes("undefined")) {
      return;
    }
    this.labsPageService.getLabsPages(queryStr).subscribe((res) => {
      const keys = Object.keys(res);
      if (keys.some((x) => x !== "Error")) {
        this.isDisabled = keys.length === 0 ? true : false;
        keys.forEach((key) => {
          if (res[key].length === 0) {
            delete res[key];
          }
        });
        this.labsPages = res;
      }
    });
  }

  public pageSelected(page: PageInfo) {
    this.labsPageService.labsPagesParams = page.paramsobj;
    this.labsPageService.recentlyNavigatedPage = this.pageName;
    this.router.navigate([page.laburl], { queryParams: page.paramsobj });
  }

  public createQueryString() {
    let queryStr = "";
    const keys = Object.keys(this.labsPagesParams);
    let counter = 1;
    keys.forEach((key) => {
      if (counter === 1) {
        queryStr = `?${key}=${this.labsPagesParams[key]}`;
      } else {
        queryStr = `${queryStr}&${key}=${this.labsPagesParams[key]}`;
      }
      counter = counter + 1;
    });
    return queryStr;
  }

  private detectPageChange(currPage, prevPage): boolean {
    if (currPage !== prevPage) {
      // Changes detected
      return true;
    }
    return false;
  }

  private detectParameterChange(pageName: string, curr, prev): boolean {
    let changeDetected = false;
    try {
      switch (pageName) {
        case "comps": {
          if (curr["compsid"] !== prev["compsid"]) {
            changeDetected = true;
          }
          break;
        }
        case "company": {
          if (curr["ticker"] !== prev["ticker"]) {
            changeDetected = true;
          }
          break;
        }
        case "broker": {
          if (curr["source"] !== prev["source"]) {
            changeDetected = true;
          }
          break;
        }
        case "analyst": {
          if (curr["analystid"] !== prev["analystid"]) {
            changeDetected = true;
          }
          break;
        }
        default:
          changeDetected = false;
          break;
      }
    } catch {
      changeDetected = false;
    }
    return changeDetected;
  }
}
